/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";
import { fetchMealPlanSummaryThunk } from "../../redux/Slices/mealPlanSummarySlice";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { useDispatch, useSelector } from "react-redux";
import {
  // MEAL_CATEGORIES,
  // MEAL_PLAN_TYPES,
  // nutrientColors,
  nutrientDescriptionMap,
} from "../../utils/Constant/Constant";
import Loader from "../../components/Common/Loader";
import {
  calculateMacronutrients,
  // formatNutrientKey,
  regexUnitFind,
} from "../../utils/Utils";

function MealPlanSummary({
  recipeIds,
  mealCount,
  selectedMeals,
  targetCalories,
  isPercentageValid,
  isEachMealPercentageValid,
  targetProtein,
  targetCarbs,
  targetFat,
}) {
  const dispatch = useDispatch();

  const { profileData } = useSelector((state) => state.profile);
  const coachId = profileData?.coachId;

  const { mealPlanSummary, isloading } = useSelector(
    (state) => state.getMealPlanSUmmary,
  );


  useEffect(() => {
    if (
      recipeIds &&
      selectedMeals &&
      isPercentageValid &&
      isEachMealPercentageValid
    ) {
      const mealType = mealCount;
      dispatch(fetchMealPlanSummaryThunk({ coachId, recipeIds, mealType }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipeIds]);
  const { trans } = useCustomTranslation();
  const [formData, setFormData] = useState({
    dailyIntake: "",
    proteinPercentage: "",
    carbsPercentage: "",
    fatPercentage: "",
    proteinGrams: "",
    carbsGrams: "",
    fatGrams: "",
  });

  useEffect(() => {
    if (
      targetCalories &&
      mealPlanSummary?.proteinPercentage &&
      mealPlanSummary?.carbsPercentage &&
      mealPlanSummary?.fatPercentage
    ) {
      const { protein, carbs, fat } = calculateMacronutrients(
        Number(targetCalories),
        Number(mealPlanSummary?.proteinPercentage),
        Number(mealPlanSummary?.carbsPercentage),
        Number(mealPlanSummary?.fatPercentage),
      );

      setFormData((prev) => ({
        ...prev,
        proteinGrams: Math.round(protein),
        carbsGrams: Math.round(carbs),
        fatGrams: Math.round(fat),
      }));
    }
  }, [
    targetCalories,
    mealPlanSummary?.proteinPercentage,
    mealPlanSummary?.carbsPercentage,
    mealPlanSummary?.fatPercentage,
  ]);
  const [showAllMicronutrients, setShowAllMicronutrients] = useState(false);

  const extractUnitFromDescription = (description) => {
    if (!description) return "";
    const match = regexUnitFind(description);
    if (match && match[2]) {
      let unit = match[2].toLowerCase();
      if (unit === "mcg") unit = "µg";
      if (
        unit === "mg/day" ||
        unit === "g/day" ||
        unit === "µg/day" ||
        unit === "mcg/day"
      ) {
        unit = unit.replace("/day", "");
      }
      return unit;
    }
    if (/kilocalories/i.test(description)) return "kcal";
    if (/calories/i.test(description)) return "kcal";
    if (/units/i.test(description)) return "IU";
    return ""; // no unit found
  };

  return (
    <div>
      {isloading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div>
          {mealPlanSummary && (
            <div>
              <div>
                <h6>{trans("ClientMealPlan.macroNutrientsSummary")}</h6>
                <div className="mt-2">
                  <section className="macronutrient-summary">
                    <header className="summary-header">
                      <div className="calories-range">
                        {Math.round(mealPlanSummary.totalCalories)}{" "}
                        {trans("ClientMealPlan.kcal")}
                      </div>
                      <div className="calories-target">
                        {trans("ClientMealPlan.target") + " "}{" "}
                        {Math.round(targetCalories)}{" "}
                        {trans("ClientMealPlan.kcal")}
                      </div>
                    </header>
                    <div className="macro-list">
                      {/* Protein */}
                      <div className="macro-item protein">
                        <div className="macro-label">
                          {trans("ClientMealPlan.protein")}
                        </div>
                        <div className="macro-data">
                          <span className="macro-percentage">
                            {Math.round(
                              (mealPlanSummary?.averageProtein /
                                targetProtein) *
                                100,
                            ) + "%" || trans("ClientMealPlan.na")}
                          </span>
                          <span className="macro-grams">
                            {mealPlanSummary?.averageProtein &&
                            targetProtein ? (
                              <>
                                {Math.round(mealPlanSummary?.averageProtein)}{" "}
                                {extractUnitFromDescription(
                                  mealPlanSummary.proteinDescription,
                                ) || "g"}
                                /{Math.round(targetProtein)}g
                              </>
                            ) : (
                              <>0g</>
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Carbs */}
                      <div className="macro-item carbs">
                        <div className="macro-label">
                          {trans("ClientMealPlan.carbs")}
                        </div>
                        <div className="macro-data">
                          <span className="macro-percentage">
                            {Math.round(
                              (mealPlanSummary?.averageCarbs / targetCarbs) *
                                100,
                            ) + "%" || trans("ClientMealPlan.na")}
                          </span>
                          <span className="macro-grams">
                            {mealPlanSummary?.averageCarbs && targetCarbs ? (
                              <>
                                {Math.round(mealPlanSummary?.averageCarbs)}{" "}
                                {extractUnitFromDescription(
                                  mealPlanSummary.carbsDescription,
                                ) || "g"}
                                /{Math.round(targetCarbs)}g
                              </>
                            ) : (
                              <>0g</>
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Fat */}
                      <div className="macro-item fat">
                        <div className="macro-label">
                          {trans("ClientMealPlan.fat")}
                        </div>
                        <div className="macro-data">
                          <span className="macro-percentage">
                            {Math.round(
                              (mealPlanSummary?.averageFat / targetFat) * 100,
                            ) + "%" || trans("ClientMealPlan.na")}
                          </span>
                          <span className="macro-grams">
                            {mealPlanSummary?.averageFat && targetFat ? (
                              <>
                                {Math.round(mealPlanSummary?.averageFat)}{" "}
                                {extractUnitFromDescription(
                                  mealPlanSummary.fatDescription,
                                ) || "g"}
                                /{Math.round(targetFat)}g
                              </>
                            ) : (
                              <>0g</>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="d-flex align-items-center micro-nutrients">
                    <h6>{trans("ClientMealPlan.micronutrients")}</h6>
                    <h6
                      className="mx-2 mb-0 showall-text"
                      role="button"
                      onClick={() => setShowAllMicronutrients((prev) => !prev)}
                    >
                      {showAllMicronutrients
                        ? trans("ClientMealPlan.showLess")
                        : trans("ClientMealPlan.showMore")}
                    </h6>
                  </div>

                  <Row>
                    <Col xs={12}>
                      <div className="d-flex flex-wrap">
                        {Object.entries(mealPlanSummary)
                          .filter(
                            ([key]) =>
                              key.endsWith("Percentage") &&
                              ![
                                "proteinPercentage",
                                "carbsPercentage",
                                "fatPercentage",
                                "caloriesPercentage",
                                "vitaminDPercentage",
                                "vitaminB12Percentage",
                                "vitaminAPercentage",
                              ].includes(key),
                          )
                          .slice(0, showAllMicronutrients ? undefined : 6)
                          .map(([key, value]) => {
                            const rawLabel = key.replace("Percentage", "");
                            const label = rawLabel
                              .replace(/([A-Z])/g, " $1")
                              .replace(/^./, (str) => str.toUpperCase());

                            const camelLabel = rawLabel;
                            const averageKey = `average${camelLabel
                              .charAt(0)
                              .toUpperCase()}${camelLabel.slice(1)}`;
                            const averageValue = mealPlanSummary[averageKey];

                            const descriptionKey =
                              nutrientDescriptionMap[camelLabel];
                            const description = descriptionKey
                              ? mealPlanSummary[descriptionKey]
                              : "";

                            const total =
                              averageValue && value
                                ? Math.round((averageValue * 100) / value)
                                : null;

                            const unit =
                              extractUnitFromDescription(description) || "g";

                            return (
                              <div key={key} className="mb-3 pe-3 w-50">
                                <h6 className="text-capitalize mb-1">
                                  {label}
                                </h6>
                                <span
                                  className={`description-font ${
                                    description ? "p-0" : "p-2"
                                  }`}
                                >
                                  {description}
                                </span>
                                <div className="position-relative bg-light rounded-pill text-dark progress-mela-summary">
                                  <div
                                    className="progress-value-meal"
                                    style={{
                                      width: `${Math.round(value)}%`,
                                    }}
                                  >
                                    {Math.round(value)}%
                                  </div>
                                  <div
                                    className="position-absolute end-0 top-50 translate-middle-y pe-2 text-white"
                                    style={{ fontSize: "0.85rem" }}
                                  >
                                    {averageValue && total
                                      ? `${Math.round(averageValue)} ${unit} / ${Math.round(total)} ${unit}`
                                      : trans("ClientMealPlan.na")}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </Col>
                  </Row>

                  {/* Full Pie Chart */}
                  {/* <div className="mt-4 pie-meal-plan">
                    <h6 className="mb-3">
                      {trans("ClientMealPlan.microBreakdown")}
                    </h6>
                    <ResponsiveContainer>
                      <PieChart>
                        <Pie
                          data={pieData}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={100}
                        >
                          {pieData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>

                        <Tooltip
                          formatter={(value, name, props) => {
                            const data = props.payload;
                            const rawAverage = parseFloat(data.average);

                            return [
                              isNaN(rawAverage)
                                ? trans("ClientMealPlan.na")
                                : `${value}% (${rawAverage.toFixed(2)} g)`,
                              name ? formatNutrientKey(name) : "",
                            ];
                          }}
                        />

                        <Legend
                          formatter={(value) => formatNutrientKey(value)}
                          wrapperStyle={{ height: 50 }}
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MealPlanSummary;
